// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_overall_result_enum */
var TestOverallResultEnum;
(function (TestOverallResultEnum) {
    TestOverallResultEnum["PASS"] = "PASS";
    TestOverallResultEnum["FAIL"] = "FAIL";
    TestOverallResultEnum["INCONCLUSIVE"] = "INCONCLUSIVE";
    TestOverallResultEnum["PENDING"] = "PENDING";
})(TestOverallResultEnum || (TestOverallResultEnum = {}));
;
export default TestOverallResultEnum;
/** Zod schema for test_overall_result_enum */
export const testOverallResultEnum = z.nativeEnum(TestOverallResultEnum);
//# sourceMappingURL=TestOverallResultEnum.js.map